import React from "react";
import { useState, useEffect } from "react";
import {
  TitleComponent,
  CardComponent,
  TableComponent,
  ButtonActionComponent,
  ButtonGenerateComponent,
  SelectComponent,
  SelectComponentMulti,
  CheckboxComponent,
} from "../../../components/pages/index";
import { api, apiConfig } from "../../../util/api";
import { useGetApiWs } from "../../../hooks/index";
import { getInfoUser } from "../../../util/auth";

const VtaResInvValDrot = (props) => {
  const urlCustomer = useGetApiWs("admin", "entity", "company-get");
  const urlCustonerInfo = useGetApiWs("admin", "entity", "customer-get");
  const urlFilter = useGetApiWs("admin", "entity", "generate-report");

  const [defcities, setDefCities] = useState([]);
  const [defattributes, setDefAttributes] = useState([]);
  const [defchannels, setDefChannels] = useState([]);
  const [defMeasurements, setDefMeasurements] = useState([]);

  const [cities, setCities] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [category, setCategory] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [channels, setChannels] = useState([]);
  const [valores, setValores] = useState([
    { value: "CONSUMO SOLES ABS", label: "CONSUMO SOLES ABS" },
    { value: "CONSUMO SOLES SOM", label: "CONSUMO SOLES SOM" },
    { value: "CONSUMO VOLUMEN ABS", label: "CONSUMO VOLUMEN ABS" },
    { value: "CONSUMO VOLUMEN SOM", label: "CONSUMO VOLUMEN SOM" },
    { value: "INVENTARIO ABS", label: "INVENTARIO ABS" },
    { value: "INVENTARIO SOM", label: "INVENTARIO SOM" },
    { value: "DN", label: "DN" },
    { value: "DROT", label: "DIAS DE ROTACION" },
    { value: "PRECIO MODA", label: "PRECIO MODA" },
    { value: "PRECIO PROMEDIO", label: "PRECIO PROMEDIO" },
    { value: "PRECIO PROMEDIO SIMPLE", label: "PRECIO PROMEDIO SIMPLE" },
  ]);
  const [measurement, setMeasurement] = useState([]);

  const [lbCategory, setLbCategory] = useState(null);
  const [lbCustomer, setLbCustomer] = useState(null);
  const [lbCities, setLbCities] = useState(null);
  const [lbAttributes, setLbAttributes] = useState(null);
  const [lbChannels, setLbChannels] = useState(null);
  const [lbValores, setLbValores] = useState([]);
  const [lbMeasurement, setLbMeasurement] = useState(null);

  const [customerIsLoading, setCustomerIsLoading] = useState(true);
  const [categoryIsLoading, setCategoryIsLoading] = useState(true);
  const [citiesIsLoading, setCitiesIsLoading] = useState(true);
  const [attributesIsLoading, setAttributesIsLoading] = useState(true);
  const [channelsIsLoading, setChannelsIsLoading] = useState(true);
  const [measurementLoading, setMeasurementIsLoading] = useState(true);

  const [channelsIsDisabled, setChannelsIsDisabled] = useState(false);

  const [tbHeadings, setTbDataHeadings] = useState([]);
  const [btnExports, setBtnExports] = useState(false);
  const [tbColumns, setTbColumns] = useState([]);
  const [tbData, setTbData] = useState([]);
  const [tbPending, setTbPending] = useState(false);

  const [Disabled, setDisabled] = useState();
  const data = JSON.parse(getInfoUser());
  // estado nuevo
  const [valorPrincipal, setValorPrincipal] = useState(null);
  //CHECK IS TOTALIZED
  const [checkedIsTotalized, setCheckedIsTotalized] = useState(true);
  const handleChangeIsTotalized = (nextChecked) => {
    setCheckedIsTotalized(nextChecked);
  };
  useEffect(() => {
    if (props.test !== 1) {
      if (
        lbCustomer?.label === "ALICORP" &&
        lbCategory?.label === "PREMEZCLAS INDUSTRIALES" &&
        lbCities?.some((city) => city.label === "PUCALLPA") &&
        lbCities?.length > 0
      ) {
        const newValores = [
          { value: "CONSUMO SOLES ABS", label: "CONSUMO SOLES ABS" },
          { value: "CONSUMO VOLUMEN ABS", label: "CONSUMO VOLUMEN ABS" },
          { value: "INVENTARIO ABS", label: "INVENTARIO ABS" },
          { value: "CONSUMO SOLES SOM", label: "CONSUMO SOLES SOM" },
          { value: "CONSUMO VOLUMEN SOM", label: "CONSUMO VOLUMEN SOM" },
          { value: "INVENTARIO SOM", label: "INVENTARIO SOM" },
          { value: "DN", label: "DN" },
          { value: "DP", label: "DP" },
          { value: "DIAS DE ROTACION", label: "DIAS DE ROTACION" },
          { value: "PRECIO MODA", label: "PRECIO MODA" },
          { value: "PRECIO PROMEDIO", label: "PRECIO PROMEDIO" },
          { value: "PRECIO PROMEDIO SIMPLE", label: "PRECIO PROMEDIO SIMPLE" },
        ];
        setValorPrincipal(newValores);
        setValores(newValores);
        setLbValores(newValores);
      } else if (
        lbCustomer?.label === "ALICORP" &&
        lbCategory?.label !== "PREMEZCLAS INDUSTRIALES" &&
        lbCategory?.label !== "MARGARINAS INDUSTRIALES" &&
        !lbCities?.some(
          (city) =>
            city.label === "CHIMBOTE" ||
            city.label === "PUCALLPA" ||
            city.label === "TACNA" ||
            city.label === "IQUITOS"
        ) &&
        lbCities?.length > 0
      ) {
        const newValores = [
          { value: "CONSUMO SOLES ABS", label: "CONSUMO SOLES ABS" },
          { value: "CONSUMO VOLUMEN ABS", label: "CONSUMO VOLUMEN ABS" },
          { value: "INVENTARIO ABS", label: "INVENTARIO ABS" },
          { value: "CONSUMO SOLES SOM", label: "CONSUMO SOLES SOM" },
          { value: "CONSUMO VOLUMEN SOM", label: "CONSUMO VOLUMEN SOM" },
          { value: "INVENTARIO SOM", label: "INVENTARIO SOM" },
          { value: "DN", label: "DN" },
          { value: "DP", label: "DP" },
          { value: "DROT", label: "DIAS DE ROTACION" },
          { value: "PRECIO MODA", label: "PRECIO MODA" },
          { value: "PRECIO PROMEDIO", label: "PRECIO PROMEDIO" },
          { value: "PRECIO PROMEDIO SIMPLE", label: "PRECIO PROMEDIO SIMPLE" },
        ];
        setValorPrincipal(newValores);
        setValores(newValores);
        setLbValores(newValores);
      } else if (
        lbCustomer?.label === "ALICORP" &&
        lbCategory?.label === "PREMEZCLAS INDUSTRIALES" &&
        lbCities?.some((city) => city.label === "CHIMBOTE") &&
        lbCities?.length > 0
      ) {
        // Caso específico para "PUCALLPA"
        const newValores = [
          { value: "CONSUMO SOLES SOM", label: "CONSUMO SOLES SOM" },
          { value: "CONSUMO VOLUMEN SOM", label: "CONSUMO VOLUMEN SOM" },
          { value: "INVENTARIO SOM", label: "INVENTARIO SOM" },
          { value: "DN", label: "DN" },
          { value: "PRECIO MODA", label: "PRECIO MODA" },
          { value: "PRECIO PROMEDIO", label: "PRECIO PROMEDIO" },
          { value: "PRECIO PROMEDIO SIMPLE", label: "PRECIO PROMEDIO SIMPLE" },
        ];
        setValorPrincipal(newValores);
        setValores(newValores);
        setLbValores(newValores);
      } else if (
        lbCustomer?.label === "ALICORP" &&
        lbCities?.some(
          (city) =>
            city.label === "IQUITOS" ||
            city.label === "TACNA" ||
            city.label === "CHIMBOTE"
        ) &&
        lbCategory?.label === "PREMEZCLAS INDUSTRIALES"
      ) {
        const newValores = [
          // { value: "CONSUMO SOLES SOM", label: "CONSUMO SOLES SOM" },
          // { value: "CONSUMO VOLUMEN SOM", label: "CONSUMO VOLUMEN SOM" },
          // { value: "INVENTARIO SOM", label: "INVENTARIO SOM" },
          { value: "DN", label: "DN" },
          { value: "PRECIO MODA", label: "PRECIO MODA" },
          { value: "PRECIO PROMEDIO", label: "PRECIO PROMEDIO" },
          { value: "PRECIO PROMEDIO SIMPLE", label: "PRECIO PROMEDIO SIMPLE" },
        ];
        setValorPrincipal(newValores);
        setValores(newValores);
        setLbValores(newValores);
      } else if (
        lbCustomer?.label === "ALICORP" &&
        lbCities?.some((city) => city.label === "CHIMBOTE") &&
        lbCategory?.label === "MARGARINAS INDUSTRIALES"
      ) {
        const newValores = [
          // { value: "CONSUMO SOLES SOM", label: "CONSUMO SOLES SOM" },
          // { value: "CONSUMO VOLUMEN SOM", label: "CONSUMO VOLUMEN SOM" },
          // { value: "INVENTARIO SOM", label: "INVENTARIO SOM" },
          { value: "DN", label: "DN" },
          { value: "PRECIO MODA", label: "PRECIO MODA" },
          { value: "PRECIO PROMEDIO", label: "PRECIO PROMEDIO" },
          { value: "PRECIO PROMEDIO SIMPLE", label: "PRECIO PROMEDIO SIMPLE" },
        ];
        setValorPrincipal(newValores);
        setValores(newValores);
        setLbValores(newValores);
      } else if (
        lbCustomer?.label === "ALICORP" &&
        lbCities?.some(
          (city) => city.label === "TACNA" || city.label === "IQUITOS"
        ) &&
        lbCategory?.label === "MARGARINAS INDUSTRIALES"
      ) {
        const newValores = [
          { value: "CONSUMO SOLES SOM", label: "CONSUMO SOLES SOM" },
          { value: "CONSUMO VOLUMEN SOM", label: "CONSUMO VOLUMEN SOM" },
          { value: "INVENTARIO SOM", label: "INVENTARIO SOM" },
          { value: "DN", label: "DN" },
          { value: "PRECIO MODA", label: "PRECIO MODA" },
          { value: "PRECIO PROMEDIO", label: "PRECIO PROMEDIO" },
          { value: "PRECIO PROMEDIO SIMPLE", label: "PRECIO PROMEDIO SIMPLE" },
        ];
        setValorPrincipal(newValores);
        setValores(newValores);
        setLbValores(newValores);
      } else if (
        lbCustomer?.label === "ALICORP" &&
        lbCities?.some((city) => city.label === "IQUITOS") &&
        lbCategory?.label === "MARGARINAS INDUSTRIALES"
      ) {
        const newValores = [
          { value: "CONSUMO SOLES ABS", label: "CONSUMO SOLES ABS" },
          { value: "CONSUMO VOLUMEN ABS", label: "CONSUMO VOLUMEN ABS" },
          { value: "INVENTARIO ABS", label: "INVENTARIO ABS" },
          { value: "CONSUMO SOLES SOM", label: "CONSUMO SOLES SOM" },
          { value: "CONSUMO VOLUMEN SOM", label: "CONSUMO VOLUMEN SOM" },
          { value: "INVENTARIO SOM", label: "INVENTARIO SOM" },
          { value: "DN", label: "DN" },
          { value: "DP", label: "DP" },
          { value: "PRECIO MODA", label: "PRECIO MODA" },
          { value: "PRECIO PROMEDIO", label: "PRECIO PROMEDIO" },
          { value: "PRECIO PROMEDIO SIMPLE", label: "PRECIO PROMEDIO SIMPLE" },
        ];
        setValorPrincipal(newValores);
        setValores(newValores);
        setLbValores(newValores);
      } else {
        const newValores = [
          { value: "CONSUMO SOLES ABS", label: "CONSUMO SOLES ABS" },
          { value: "CONSUMO VOLUMEN ABS", label: "CONSUMO VOLUMEN ABS" },
          { value: "INVENTARIO ABS", label: "INVENTARIO ABS" },
          { value: "CONSUMO SOLES SOM", label: "CONSUMO SOLES SOM" },
          { value: "CONSUMO VOLUMEN SOM", label: "CONSUMO VOLUMEN SOM" },
          { value: "INVENTARIO SOM", label: "INVENTARIO SOM" },
          { value: "DN", label: "DN" },
          { value: "DP", label: "DP" },
          { value: "DIAS DE ROTACION", label: "DIAS DE ROTACION" },
          { value: "PRECIO MODA", label: "PRECIO MODA" },
          { value: "PRECIO PROMEDIO", label: "PRECIO PROMEDIO" },
          { value: "PRECIO PROMEDIO SIMPLE", label: "PRECIO PROMEDIO SIMPLE" },
        ];
        setValorPrincipal(newValores);
        setValores(newValores);
        setLbValores(newValores);
      }
    }
  }, [lbCustomer, lbCategory, lbCities, props.test]);

  const wbname = "VtaResInValDrot";
  const fetchCustomers = async () => {
    const customers = await api().post(
      urlCustomer,
      { company_type_code: "CM-CUST" },
      apiConfig()
    );
    var options = customers.data.response.map((obj) => {
      var rObj = {};
      rObj["value"] = obj.company_id;
      rObj["label"] = obj.description;
      return rObj;
    });
    setCustomers(options);
    setCustomerIsLoading(false);
    if (data.code == "CM-CUST") {
      CustomerChange({ value: data.company_id, label: data.company_name });
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };
  const fetchCategory = async (customer_id) => {
    const ob = {};
    ob["customer_id"] = customer_id;
    ob["study_id"] = 17;
    ob["type_info"] = "categories";
    if (props.test !== null || props.test !== undefined) {
      ob["is_test"] = props.test;
    } else {
      ob["is_test"] = 0;
    }
    const cWorkOrders = await api().post(urlCustonerInfo, ob, apiConfig());
    if (cWorkOrders.status === 200 && cWorkOrders.data.status === "success") {
      var options = cWorkOrders.data.response.map((obj) => {
        var rObj = {};
        rObj["value"] = obj.category_id;
        rObj["label"] = obj.category_name;
        return rObj;
      });
      setCategory(options);
    }
    setCategoryIsLoading(false);
  };
  const fetchAttributes = async (category_id, customer_id) => {
    const ob = {};
    ob["customer_id"] = customer_id;
    ob["category_id"] = category_id;
    ob["study_id"] = 17;
    ob["type_info"] = "attributes";
    if (props.test !== null || props.test !== undefined) {
      ob["is_test"] = props.test;
    } else {
      ob["is_test"] = 0;
    }
    const customers = await api().post(urlCustonerInfo, ob, apiConfig());
    var options = customers.data.response.map((obj) => {
      var rObj = {};
      rObj["value"] = obj.feature_type_id;
      rObj["label"] = obj.feature_type_name;
      return rObj;
    });
    setAttributes(options);
    setAttributesIsLoading(false);
  };

  const fetchCities = async (category_id, customer_id) => {
    const ob = {};
    ob["customer_id"] = customer_id;
    ob["category_id"] = category_id;
    ob["study_id"] = 17;
    ob["type_info"] = "cities";
    if (props.test !== null || props.test !== undefined) {
      ob["is_test"] = props.test;
    } else {
      ob["is_test"] = 0;
    }
    const customers = await api().post(urlCustonerInfo, ob, apiConfig());
    var options = customers.data.response.map((obj) => {
      var rObj = {};
      rObj["value"] = obj.city_id;
      rObj["label"] = obj.name;
      return rObj;
    });
    setCities(options);
    setCitiesIsLoading(false);
  };

  const fetchMeasurement = async (category_id, customer_id) => {
    const ob = {};
    ob["customer_id"] = customer_id;
    ob["category_id"] = category_id;
    ob["study_id"] = 17;
    ob["type_info"] = "measurements";
    if (props.test !== null || props.test !== undefined) {
      ob["is_test"] = props.test;
    } else {
      ob["is_test"] = 0;
    }
    const measurement = await api().post(urlCustonerInfo, ob, apiConfig());
    var options = measurement.data.response.map((obj) => {
      var rObj = {};
      rObj["value"] = obj.measurement_id;
      rObj["label"] = obj.description;
      return rObj;
    });
    setMeasurement(options);
    setMeasurementIsLoading(false);
  };

  const CustomerChange = async (vals) => {
    setLbCustomer(vals);
    if (vals === null) {
      setCategory([]);
      setLbCategory(null);
    } else {
      setCategory([]);
      setLbCategory(null);
      fetchCategory(vals.value);
    }
  };

  const CategoryChange = async (vals) => {
    ClearForm();
    setLbCategory(vals);
    if (vals !== null) {
      fetchAttributes(vals.value, lbCustomer.value);
      fetchCities(vals.value, lbCustomer.value);
      fetchMeasurement(vals.value, lbCustomer.value);
    }
  };

  const CityChange = async (vals) => {
    setLbCities(vals);
  };

  const MeasurementChange = async (vals) => {
    setLbMeasurement(vals);
  };

  const Filter = () => {
    fetchFilters();
  };
  const ClearForm = () => {
    setAttributes([]);
    setCities([]);
    setChannels([]);
    setMeasurement([]);

    setLbMeasurement([]);
    setLbAttributes([]);
    setLbCities([]);
    setLbChannels([]);

    setDefAttributes([]);
    setDefCities([]);
    setDefChannels([]);
    setDefMeasurements([]);

    setAttributesIsLoading(false);
    setCitiesIsLoading(false);
    setChannelsIsLoading(false);
    setChannelsIsDisabled(false);
    setMeasurementIsLoading(false);
    setBtnExports(false);
    setTbData([]);
    setTbPending(false);
  };

  const fetchFilters = async () => {
    if (
      lbCategory !== null &&
      lbChannels !== null &&
      lbAttributes !== null &&
      lbCities !== null &&
      valores !== null
    ) {
      setTbPending(true);
      const ob = {};
      ob["type"] = "consumo_resumen_inventario_drotacion";
      ob["customer_id"] = lbCustomer.value;
      ob["category_id"] = lbCategory.label + "|" + lbCategory.value + "|";

      const fea = lbAttributes.map((obj) => {
        return obj.label + "|" + obj.value + "|";
      });
      const mea = lbMeasurement.map((obj) => {
        return obj.label + "|" + obj.value + "|";
      });
      const cit = lbCities.map((obj) => {
        return obj.label + "|" + obj.value + "|";
      });
      const data = lbValores.map((obj) => {
        return obj.label + "|" + obj.label + "|";
      });

      ob["is_totalized"] = checkedIsTotalized ? 1 : 0;

      ob["features"] = fea.join(",");
      ob["cities"] = cit.join(",");
      ob["measurement_id"] = mea.join(",");
      ob["data_types"] = data.join(",");
      ob["is_for_export"] = 0;
      if (props.test) {
        ob["is_test"] = 1;
      } else {
        ob["is_test"] = 0;
      }

      var headers = [];
      const res = await api().post(urlFilter, ob, apiConfig());
      if (res.data.status === "success") {
        let colum = [];
        if (res.data.response.length > 0) {
          const head = res.data.response[0];
          headers = Object.keys(head);
          for (var h in headers) {
            colum.push({
              name: headers[h],
              selector: headers[h],
              sortable: false,
              wrap: true,
            });
          }
          setBtnExports(true);
          setTbColumns(colum);
          setTbData(res.data.response);
          setTbPending(false);
        } else {
          setBtnExports(false);
          setTbColumns([]);
          setTbData([]);
          setTbPending(false);
        }
      }
    } else {
      return null;
    }
  };

  useEffect(() => {
    fetchCustomers();
    setCategory([]);
    setValores([
      {
        value: "CONSUMO SOLES ABS",
        label: "CONSUMO SOLES ABS",
      },
      {
        value: "CONSUMO SOLES SOM",
        label: "CONSUMO SOLES SOM",
      },
      {
        value: "CONSUMO VOLUMEN ABS",
        label: "CONSUMO VOLUMEN ABS",
      },
      {
        value: "CONSUMO VOLUMEN SOM",
        label: "CONSUMO VOLUMEN SOM",
      },
      {
        value: "INVENTARIO ABS",
        label: "INVENTARIO ABS",
      },
      {
        value: "INVENTARIO SOM",
        label: "INVENTARIO SOM",
      },
      {
        value: "DN",
        label: "DN",
      },
      {
        value: "DP",
        label: "DP",
      },
      { value: "DIAS DE ROTACION", label: "DIAS DE ROTACION" },
      {
        value: "PRECIO MODA",
        label: "PRECIO MODA",
      },
      {
        value: "PRECIO PROMEDIO",
        label: "PRECIO PROMEDIO",
      },
      {
        value: "PRECIO PROMEDIO SIMPLE",
        label: "PRECIO PROMEDIO SIMPLE",
      },
    ]);

    ClearForm();
  }, []);

  return (
    <div>
      <TitleComponent title="Auditoría | Reporte | Resumen Consumo / Inventario / D. Rotación" />
      <div className="pt-3">
        <CardComponent header={null} footer={null}>
          <div className="bg-white p-2">
            <div className="grid md:grid-cols-4 lg:grid-cols-4 items-center gap-4">
              <SelectComponent
                onChange={CustomerChange}
                options={customers}
                value={lbCustomer}
                isLoading={customerIsLoading}
                label="Clientes"
                isDisabled={Disabled}
              />
              <SelectComponent
                onChange={CategoryChange}
                options={category}
                value={lbCategory}
                isLoading={categoryIsLoading}
                label="Categoría"
              />
              <SelectComponentMulti
                onChange={(vals) => {
                  setLbAttributes(vals);
                }}
                defaultValue={defattributes}
                value={lbAttributes}
                options={attributes}
                isLoading={attributesIsLoading}
                label="Atributos"
              />
              <SelectComponentMulti
                onChange={CityChange}
                defaultValue={defcities}
                options={cities}
                isLoading={citiesIsLoading}
                value={lbCities}
                label="Ciudades"
              />
              <SelectComponentMulti
                onChange={(vals) => {
                  MeasurementChange(vals);
                }}
                options={measurement}
                value={lbMeasurement}
                label="Medición"
              />
              <SelectComponentMulti
                onChange={(vals) => {
                  setLbValores(vals);
                }}
                options={Array.isArray(valores) ? valores : []}
                label="Tipo de Datos"
              />
              <div className="self-start">
                <label className="block font-medium ">Totalizado</label>
                <CheckboxComponent
                  onChange={handleChangeIsTotalized}
                  isOn={checkedIsTotalized}
                  className={"align-middle"}
                  id={"chkIsTotalized"}
                />
              </div>
            </div>
            <div className="bg-white p-2 justify-items-end grid">
              <div className="space-x-4">
                <ButtonActionComponent
                  name="GENERAR REPORTE"
                  onClick={Filter}
                />
                {btnExports ? (
                  <ButtonGenerateComponent
                    name="EXPORTAR EXCEL"
                    onClick={props.createDataExcel}
                    tbColumns={tbColumns}
                    tbData={tbData}
                    lbCustomer={lbCustomer}
                    lbCategory={lbCategory}
                    lbCities={lbCities}
                    lbAttributes={lbAttributes}
                    lbChannels={lbChannels}
                    lbMeasurement={lbMeasurement}
                    wbname={wbname}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </CardComponent>
      </div>

      <div className="pt-3">
        <CardComponent
          header={
            <h4 className="">Resumen Consumo / Inventario / D. Rotación</h4>
          }
          footer={null}
        >
          <div className="bg-white">
            <TableComponent
              keyField="work_order_id"
              columns={tbColumns}
              headItem={tbHeadings}
              data={tbData}
              pending={tbPending}
              highlightOnHover={true}
            />
          </div>
        </CardComponent>
      </div>
    </div>
  );
};
export default VtaResInvValDrot;
